import { render, staticRenderFns } from "./TaskStatusChip.vue?vue&type=template&id=6dbc4c64"
import script from "./TaskStatusChip.vue?vue&type=script&lang=js"
export * from "./TaskStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports